const baseMediaQuery = "@media (min-width: ";

export const xs = (styles, mediaStyles) => {
  styles["@media (max-width: 40em)"] = mediaStyles;
};

export const sm = (styles, mediaStyles) => {
  styles[baseMediaQuery + "40em)"] = mediaStyles;
};

export const md = (styles, mediaStyles) => {
  styles[baseMediaQuery + "52em)"] = mediaStyles;
};

export const lg = (styles, mediaStyles) => {
  styles[baseMediaQuery + "64em)"] = mediaStyles;
};

export const serifFontFamily = '"Bitter", "Georgia", "Times New Roman", serif';

export const buttonColors = {
  backgroundColor: "#FFF",
  borderColor: "magenta",
  color: "magenta",
  ":hover": {
    backgroundColor: "magenta",
    color: "white",
  },
  ":active, :focus, .isActive": {
    backgroundColor: "#ce00cb",
    color: "#FFF",
    borderColor: "#ce00cb",
  },
};



// WEBPACK FOOTER //
// ./src/utilities/styles.js